function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { HttpClient } from 'api/http-client';
const filtersToParams = (filters)=>{
    var _filters_responsibleCompanyIds, _filters_budgetIds;
    if (!filters) {
        return {};
    }
    return {
        ...filters.completed !== undefined && {
            completed: filters.completed
        },
        ...((_filters_responsibleCompanyIds = filters.responsibleCompanyIds) === null || _filters_responsibleCompanyIds === void 0 ? void 0 : _filters_responsibleCompanyIds.length) && {
            responsibleCompanyIds: filters.responsibleCompanyIds.join(',')
        },
        ...filters.includePrivate !== undefined && {
            includePrivate: filters.includePrivate
        },
        ...((_filters_budgetIds = filters.budgetIds) === null || _filters_budgetIds === void 0 ? void 0 : _filters_budgetIds.length) && {
            budgetIds: filters.budgetIds.join(',')
        }
    };
};
class PlanBoardAPIClient extends HttpClient {
    constructor(...args){
        super(...args), _define_property(this, "getBoard", (projectId, options = {})=>{
            var _options_expandedPhaseIds;
            return this.get(`/projects/${projectId}/board`, {
                params: {
                    ...((_options_expandedPhaseIds = options.expandedPhaseIds) === null || _options_expandedPhaseIds === void 0 ? void 0 : _options_expandedPhaseIds.length) && {
                        expandedPhaseIds: options.expandedPhaseIds.join(',')
                    },
                    ...options.limit && {
                        limit: options.limit
                    },
                    excludeMetaDataInFields: true,
                    ...filtersToParams(options.filters)
                }
            });
        }), _define_property(this, "getPhaseEntities", (projectId, phaseId, options = {})=>{
            var _options_cursor, _options_cursor1;
            return this.get(`/projects/${projectId}/phases/${phaseId}/entities`, {
                params: {
                    ...((_options_cursor = options.cursor) === null || _options_cursor === void 0 ? void 0 : _options_cursor.cursor) && {
                        cursor: options.cursor.cursor
                    },
                    ...((_options_cursor1 = options.cursor) === null || _options_cursor1 === void 0 ? void 0 : _options_cursor1.cursorIndex) !== undefined && {
                        cursorIndex: options.cursor.cursorIndex
                    },
                    ...options.limit && {
                        limit: options.limit
                    },
                    excludeMetaDataInFields: true,
                    ...filtersToParams(options.filters)
                }
            });
        }), /**
   * First entities page for up to 12 phases in one call. The plan board
   * coalesces per-lane first-page fetches through this (see
   * collections/plan-board/fetchers.ts) so a viewport settle costs one request, not one
   * per lane.
   */ _define_property(this, "getPhaseEntitiesBatch", (projectId, phaseIds, options = {})=>{
            var _options_filters, _options_filters_responsibleCompanyIds, _options_filters1, _options_filters2, _options_filters_budgetIds, _options_filters3;
            return this.post(`/projects/${projectId}/phase-entities/batch`, {
                phaseIds,
                ...options.limit && {
                    limit: options.limit
                },
                excludeMetaDataInFields: true,
                ...((_options_filters = options.filters) === null || _options_filters === void 0 ? void 0 : _options_filters.completed) !== undefined && {
                    completed: options.filters.completed
                },
                ...((_options_filters1 = options.filters) === null || _options_filters1 === void 0 ? void 0 : (_options_filters_responsibleCompanyIds = _options_filters1.responsibleCompanyIds) === null || _options_filters_responsibleCompanyIds === void 0 ? void 0 : _options_filters_responsibleCompanyIds.length) && {
                    responsibleCompanyIds: options.filters.responsibleCompanyIds
                },
                ...((_options_filters2 = options.filters) === null || _options_filters2 === void 0 ? void 0 : _options_filters2.includePrivate) !== undefined && {
                    includePrivate: options.filters.includePrivate
                },
                ...((_options_filters3 = options.filters) === null || _options_filters3 === void 0 ? void 0 : (_options_filters_budgetIds = _options_filters3.budgetIds) === null || _options_filters_budgetIds === void 0 ? void 0 : _options_filters_budgetIds.length) && {
                    budgetIds: options.filters.budgetIds
                }
            });
        }), _define_property(this, "reorderEntity", (phaseId, payload)=>{
            return this.put(`/phases/${phaseId}/update-entity-order`, payload);
        }), _define_property(this, "moveEntity", (projectId, destPhaseId, payload)=>{
            return this.put(`/projects/${projectId}/phases/${destPhaseId}/move-entity`, payload);
        });
    }
}
export const PlanBoardAPI = new PlanBoardAPIClient();
